import { TEXT_INPUT_FIELD } from "../../constants";
import { renderToString } from "jsx-async-runtime";

export type TextInputTypeProps = {
    name: string;
    placeholder?: string;
    required?: boolean;
    validator: (value: string) => string | null;
    emptyErrorMessage: string;
    label: string;
    helpText? : string;
}

export class TextInput extends HTMLElement {
  private _props : TextInputTypeProps;
  private _errorMessage : string | null;
  
  get props(){
    return this._props;
  }

  set props(value){
    this._props = value;
  }

  get errorMessage() {
    return this._errorMessage;
  }

  set errorMessage(value) {
    const inputElement = document.getElementById(`${this.props.name}-input`);
    const errorMessageElement = document.getElementById(`${this.props.name}-input-error`);

    if(!value){
      if (inputElement) 
        inputElement.classList.remove("error");
      if (errorMessageElement) 
        errorMessageElement.hidden = true;
    }

    if(errorMessageElement)
      errorMessageElement.innerText = value;
    
    if(!!value){
      if (inputElement) 
        inputElement.classList.add("error");
      if (errorMessageElement)
        errorMessageElement.hidden = false;
    }

    this._errorMessage = value;
  }

  async attachListeners() {
    const input = document.getElementById(`${this.props.name}-input`) as HTMLInputElement;
    if (input) {
      input.onblur = (event: Event) => {
        const target = event.target as HTMLInputElement;
        this.errorMessage = this.handleValidation(target.value);
      };

      input.oninput = (event: Event) => {
        const target = event.target as HTMLInputElement;
        this.errorMessage = this.handleValidation(target.value);
      };
    }
  }

  handleValidation(value: string) : string | null{
    if(this.props.required && !value)
      return this.props.emptyErrorMessage;
    if(this.props.validator)
      return this.props.validator(value);
    return null;
  }

  triggerValidation() : boolean {
    const input = document.getElementById(`${this.props.name}-input`) as HTMLInputElement;
    if (input) {
      this.errorMessage = this.handleValidation(input.value);
      return !!this.errorMessage;
    }
  }
  

  async connectedCallback() {

    const html = (
      <div class="textInputWrapper">
        <label
          class={`textInputLabel ${this.props.required ? 'required' : ''}`}
          for={`${this.props.name}-input`}
        >
          {this.props.label}
        </label>
        <input 
          class="textInputField"
          id={`${this.props.name}-input`}
          name={this.props.name}
          type="text"
          placeholder={this.props.placeholder}
          required={this.props.required}
        />
        {this.props.helpText && 
          <span class="textInputHelpText">
            {this.props.helpText}
          </span>
        }
          <span id={`${this.props.name}-input-error`} class="textInputErrorMessage">
          </span>
      </div>
    );

    this.innerHTML = await renderToString(html);
    await this.attachListeners();
  }
}

if (!customElements.get(TEXT_INPUT_FIELD)) {
  customElements.define(TEXT_INPUT_FIELD, TextInput);
}